import { FormField, FormItem, FormLabel } from "@/src/components/ui/form";
import { OperatorForm } from "./operator.schema";
import { Label } from "@/src/components/ui/label";
import { Checkbox } from "@/src/components/ui/checkbox";
import { useFormContext } from "react-hook-form";

export function VisibilitySettings() {
  const form = useFormContext<OperatorForm>();
  const [helmAppBmOverNs, helmBmOverNs, anchorBmOverNs, helmAppYfOverCya, helmYfOverCya, anchorYfOverCya] =
    form.watch([
      "visibility.helm_app_bm_over_ns",
      "visibility.helm_bm_over_ns",
      "visibility.anchor_bm_over_ns",
      "visibility.helm_app_yf_over_cya",
      "visibility.helm_yf_over_cya",
      "visibility.anchor_yf_over_cya",
    ]);

  return (
    <div className="grid gap-4 max-w-[1016px] grid-cols-[repeat(auto-fit,minmax(150px,328px))]">
      <h3 className="text-lg font-semibold col-span-full">Yacht visibility settings</h3>
      <div className="w-full flex flex-col gap-1">
        <Label className="after:content-['*'] after:ml-[2px] after:text-red-600 mb-2">
          Yachts visibility - offer creator
        </Label>
        <FormField<OperatorForm, "visibility.helm_app_hide_skippered">
          name="visibility.helm_app_hide_skippered"
          render={({ field }) => (
            <FormItem className="flex gap-2 items-center space-y-0 py-[6px] px-4">
              <Checkbox checked={field.value} onCheckedChange={field.onChange} />
              <FormLabel className="font-light text-base">Hide skippered</FormLabel>
            </FormItem>
          )}
        />
        <FormField<OperatorForm, "visibility.helm_app_cya">
          name="visibility.helm_app_cya"
          render={({ field }) => (
            <FormItem className="flex gap-2 items-center space-y-0 py-[6px] px-4">
              <Checkbox
                disabled={helmAppYfOverCya}
                checked={field.value === "visible"}
                onCheckedChange={(checked) => {
                  field.onChange(checked ? "visible" : "hidden");
                }}
              />
              <FormLabel className="font-light text-base">Central Yacht Agent</FormLabel>
            </FormItem>
          )}
        />
        <FormField<OperatorForm, "visibility.helm_app_yf_over_cya">
          name="visibility.helm_app_yf_over_cya"
          render={({ field }) => (
            <FormItem className="flex gap-2 items-center space-y-0 py-[6px] px-4">
              <Checkbox checked={field.value} onCheckedChange={field.onChange} />
              <FormLabel className="font-light text-base">Yacht Folio over CYA</FormLabel>
            </FormItem>
          )}
        />
        <FormField<OperatorForm, "visibility.helm_app_yf">
          name="visibility.helm_app_yf"
          render={({ field }) => (
            <FormItem className="flex gap-2 items-center space-y-0 py-[6px] px-4">
              <Checkbox
                disabled={helmAppYfOverCya}
                checked={field.value === "visible"}
                onCheckedChange={(checked) => {
                  field.onChange(checked ? "visible" : "hidden");
                }}
              />
              <FormLabel className="font-light text-base">Yacht Folio</FormLabel>
            </FormItem>
          )}
        />
        <FormField<OperatorForm, "visibility.helm_app_ankor">
          name="visibility.helm_app_ankor"
          render={({ field }) => (
            <FormItem className="flex gap-2 items-center space-y-0 py-[6px] px-4">
              <Checkbox
                checked={field.value === "visible"}
                onCheckedChange={(checked) => {
                  field.onChange(checked ? "visible" : "hidden");
                }}
              />
              <FormLabel className="font-light text-base">Ankor</FormLabel>
            </FormItem>
          )}
        />
        <FormField<OperatorForm, "visibility.helm_app_bm_over_ns">
          name="visibility.helm_app_bm_over_ns"
          render={({ field }) => (
            <FormItem className="flex gap-2 items-center space-y-0 py-[6px] px-4">
              <Checkbox checked={field.value} onCheckedChange={field.onChange} />
              <FormLabel className="font-light text-base">MMK over NauSys</FormLabel>
            </FormItem>
          )}
        />
        <FormField<OperatorForm, "visibility.helm_app_bm">
          name="visibility.helm_app_bm"
          render={({ field }) => (
            <FormItem className="flex gap-2 items-center space-y-0 py-[6px] px-4">
              <Checkbox
                disabled={helmAppBmOverNs}
                checked={field.value === "visible"}
                onCheckedChange={(checked) => {
                  field.onChange(checked ? "visible" : "hidden");
                }}
              />
              <FormLabel className="font-light text-base">Booking Manager</FormLabel>
            </FormItem>
          )}
        />
        <FormField<OperatorForm, "visibility.helm_app_ns">
          name="visibility.helm_app_ns"
          render={({ field }) => (
            <FormItem className="flex gap-2 items-center space-y-0 py-[6px] px-4">
              <Checkbox
                disabled={helmAppBmOverNs}
                checked={field.value === "visible"}
                onCheckedChange={(checked) => {
                  field.onChange(checked ? "visible" : "hidden");
                }}
              />
              <FormLabel className="font-light text-base">NauSYS</FormLabel>
            </FormItem>
          )}
        />
        <FormField<OperatorForm, "visibility.helm_app_helm">
          name="visibility.helm_app_helm"
          render={({ field }) => (
            <FormItem className="flex gap-2 items-center space-y-0 py-[6px] px-4">
              <Checkbox
                checked={field.value === "visible"}
                onCheckedChange={(checked) => {
                  field.onChange(checked ? "visible" : "hidden");
                }}
              />
              <FormLabel className="font-light text-base">Manually entered</FormLabel>
            </FormItem>
          )}
        />
      </div>
      <div className="w-full flex flex-col gap-1">
        <Label className="after:content-['*'] after:ml-[2px] after:text-red-600 mb-2">
          Yachts visibility - HELM website
        </Label>
        <FormField<OperatorForm, "visibility.helm_hide_skippered">
          name="visibility.helm_hide_skippered"
          render={({ field }) => (
            <FormItem className="flex gap-2 items-center space-y-0 py-[6px] px-4">
              <Checkbox checked={field.value} onCheckedChange={field.onChange} />
              <FormLabel className="font-light text-base">Hide skippered</FormLabel>
            </FormItem>
          )}
        />
        <FormField<OperatorForm, "visibility.helm_cya">
          name="visibility.helm_cya"
          render={({ field }) => (
            <FormItem className="flex gap-2 items-center space-y-0 py-[6px] px-4">
              <Checkbox
                disabled={helmYfOverCya}
                checked={field.value === "visible"}
                onCheckedChange={(checked) => {
                  field.onChange(checked ? "visible" : "hidden");
                }}
              />
              <FormLabel className="font-light text-base">Central Yacht Agent</FormLabel>
            </FormItem>
          )}
        />
        <FormField<OperatorForm, "visibility.helm_yf_over_cya">
          name="visibility.helm_yf_over_cya"
          render={({ field }) => (
            <FormItem className="flex gap-2 items-center space-y-0 py-[6px] px-4">
              <Checkbox checked={field.value} onCheckedChange={field.onChange} />
              <FormLabel className="font-light text-base">Yacht Folio over CYA</FormLabel>
            </FormItem>
          )}
        />
        <FormField<OperatorForm, "visibility.helm_yf">
          name="visibility.helm_yf"
          render={({ field }) => (
            <FormItem className="flex gap-2 items-center space-y-0 py-[6px] px-4">
              <Checkbox
                disabled={helmYfOverCya}
                checked={field.value === "visible"}
                onCheckedChange={(checked) => {
                  field.onChange(checked ? "visible" : "hidden");
                }}
              />
              <FormLabel className="font-light text-base">Yacht Folio</FormLabel>
            </FormItem>
          )}
        />
        <FormField<OperatorForm, "visibility.helm_ankor">
          name="visibility.helm_ankor"
          render={({ field }) => (
            <FormItem className="flex gap-2 items-center space-y-0 py-[6px] px-4">
              <Checkbox
                checked={field.value === "visible"}
                onCheckedChange={(checked) => {
                  field.onChange(checked ? "visible" : "hidden");
                }}
              />
              <FormLabel className="font-light text-base">Ankor</FormLabel>
            </FormItem>
          )}
        />
        <FormField<OperatorForm, "visibility.helm_bm_over_ns">
          name="visibility.helm_bm_over_ns"
          render={({ field }) => (
            <FormItem className="flex gap-2 items-center space-y-0 py-[6px] px-4">
              <Checkbox checked={field.value} onCheckedChange={field.onChange} />
              <FormLabel className="font-light text-base">MMK over NauSys</FormLabel>
            </FormItem>
          )}
        />
        <FormField<OperatorForm, "visibility.helm_bm">
          name="visibility.helm_bm"
          render={({ field }) => (
            <FormItem className="flex gap-2 items-center space-y-0 py-[6px] px-4">
              <Checkbox
                disabled={helmBmOverNs}
                checked={field.value === "visible"}
                onCheckedChange={(checked) => {
                  field.onChange(checked ? "visible" : "hidden");
                }}
              />
              <FormLabel className="font-light text-base">Booking Manager</FormLabel>
            </FormItem>
          )}
        />
        <FormField<OperatorForm, "visibility.helm_ns">
          name="visibility.helm_ns"
          render={({ field }) => (
            <FormItem className="flex gap-2 items-center space-y-0 py-[6px] px-4">
              <Checkbox
                disabled={helmBmOverNs}
                checked={field.value === "visible"}
                onCheckedChange={(checked) => {
                  field.onChange(checked ? "visible" : "hidden");
                }}
              />
              <FormLabel className="font-light text-base">NauSYS</FormLabel>
            </FormItem>
          )}
        />
        <FormField<OperatorForm, "visibility.helm_helm">
          name="visibility.helm_helm"
          render={({ field }) => (
            <FormItem className="flex gap-2 items-center space-y-0 py-[6px] px-4">
              <Checkbox
                checked={field.value === "visible"}
                onCheckedChange={(checked) => {
                  field.onChange(checked ? "visible" : "hidden");
                }}
              />
              <FormLabel className="font-light text-base">Manually entered</FormLabel>
            </FormItem>
          )}
        />
      </div>
      <div className="w-full flex flex-col gap-1">
        <Label className="after:content-['*'] after:ml-[2px] after:text-red-600 mb-2">
          Yachts visibility - Anchor website
        </Label>
        <FormField<OperatorForm, "visibility.anchor_hide_skippered">
          name="visibility.anchor_hide_skippered"
          render={({ field }) => (
            <FormItem className="flex gap-2 items-center space-y-0 py-[6px] px-4">
              <Checkbox checked={field.value} onCheckedChange={field.onChange} />
              <FormLabel className="font-light text-base">Hide skippered</FormLabel>
            </FormItem>
          )}
        />
        <FormField<OperatorForm, "visibility.anchor_cya">
          name="visibility.anchor_cya"
          render={({ field }) => (
            <FormItem className="flex gap-2 items-center space-y-0 py-[6px] px-4">
              <Checkbox
                disabled={anchorYfOverCya}
                checked={field.value === "visible"}
                onCheckedChange={(checked) => {
                  field.onChange(checked ? "visible" : "hidden");
                }}
              />
              <FormLabel className="font-light text-base">Central Yacht Agent</FormLabel>
            </FormItem>
          )}
        />
        <FormField<OperatorForm, "visibility.anchor_yf_over_cya">
          name="visibility.anchor_yf_over_cya"
          render={({ field }) => (
            <FormItem className="flex gap-2 items-center space-y-0 py-[6px] px-4">
              <Checkbox checked={field.value} onCheckedChange={field.onChange} />
              <FormLabel className="font-light text-base">Yacht Folio over CYA</FormLabel>
            </FormItem>
          )}
        />
        <FormField<OperatorForm, "visibility.anchor_yf">
          name="visibility.anchor_yf"
          render={({ field }) => (
            <FormItem className="flex gap-2 items-center space-y-0 py-[6px] px-4">
              <Checkbox
                disabled={anchorYfOverCya}
                checked={field.value === "visible"}
                onCheckedChange={(checked) => {
                  field.onChange(checked ? "visible" : "hidden");
                }}
              />
              <FormLabel className="font-light text-base">Yacht Folio</FormLabel>
            </FormItem>
          )}
        />
        <FormField<OperatorForm, "visibility.anchor_ankor">
          name="visibility.anchor_ankor"
          render={({ field }) => (
            <FormItem className="flex gap-2 items-center space-y-0 py-[6px] px-4">
              <Checkbox
                checked={field.value === "visible"}
                onCheckedChange={(checked) => {
                  field.onChange(checked ? "visible" : "hidden");
                }}
              />
              <FormLabel className="font-light text-base">Ankor</FormLabel>
            </FormItem>
          )}
        />
        <FormField<OperatorForm, "visibility.anchor_bm_over_ns">
          name="visibility.anchor_bm_over_ns"
          render={({ field }) => (
            <FormItem className="flex gap-2 items-center space-y-0 py-[6px] px-4">
              <Checkbox checked={field.value} onCheckedChange={field.onChange} />
              <FormLabel className="font-light text-base">MMK over NauSys</FormLabel>
            </FormItem>
          )}
        />
        <FormField<OperatorForm, "visibility.anchor_bm">
          name="visibility.anchor_bm"
          render={({ field }) => (
            <FormItem className="flex gap-2 items-center space-y-0 py-[6px] px-4">
              <Checkbox
                disabled={anchorBmOverNs}
                checked={field.value === "visible"}
                onCheckedChange={(checked) => {
                  field.onChange(checked ? "visible" : "hidden");
                }}
              />
              <FormLabel className="font-light text-base">Booking Manager</FormLabel>
            </FormItem>
          )}
        />
        <FormField<OperatorForm, "visibility.anchor_ns">
          name="visibility.anchor_ns"
          render={({ field }) => (
            <FormItem className="flex gap-2 items-center space-y-0 py-[6px] px-4">
              <Checkbox
                disabled={anchorBmOverNs}
                checked={field.value === "visible"}
                onCheckedChange={(checked) => {
                  field.onChange(checked ? "visible" : "hidden");
                }}
              />
              <FormLabel className="font-light text-base">NauSYS</FormLabel>
            </FormItem>
          )}
        />
        <FormField<OperatorForm, "visibility.anchor_helm">
          name="visibility.anchor_helm"
          render={({ field }) => (
            <FormItem className="flex gap-2 items-center space-y-0 py-[6px] px-4">
              <Checkbox
                checked={field.value === "visible"}
                onCheckedChange={(checked) => {
                  field.onChange(checked ? "visible" : "hidden");
                }}
              />
              <FormLabel className="font-light text-base">Manually entered</FormLabel>
            </FormItem>
          )}
        />
      </div>
    </div>
  );
}
